import { useUpdateHabitSortModeMutation } from 'shared/hooks/queries/use-update-habit-sort-mode-mutation';

export const useUpdateHabitSortMode = () => {
  const { mutate } = useUpdateHabitSortModeMutation();

  return mutate;
};
